import { AvitoStylesWrapper } from './ui/AvitoStylesWrapper';
import { PARTNER_AFF_IDS } from 'constants/partners';

export const PARTNERS_CUSTOM_THEME = {
    [PARTNER_AFF_IDS.AVITO]: { themeName: 'avito-light', Component: AvitoStylesWrapper },
} as const;
